import { SpecStrat } from '../../models/SpecStrat';
import { PATH_OF_ROUTES } from '../../router/routes';
import { Web3InteractionDecisionRq } from '../../hooks/useWeb3Interaction';
import { TransactionStatus, TransactionReason } from '../../models/Transaction';
import { Claim } from '../../models/Claim';
import { startClaim } from '../../store/claim/actions/startClaim';
import { getClaim } from '../../store/claim/actions/getClaim';
import { updateClaim } from '../../store/claim/actions/updateClaim';

export const deployClaim: SpecStrat<
  Web3InteractionDecisionRq<Claim>,
  number
> = {
  evaluateCondition: (input: Web3InteractionDecisionRq<Claim>): boolean => {
    return input.dataStore?.claim === undefined;
  },
  executeAction: (input: Web3InteractionDecisionRq<Claim>): number => {
    input.dispatch(
      startClaim({
        vestingContractAddress: input.vestingContractAddress,
        claim: input.dataStore
      })
    );
    return 0;
  }
};
export const saveDeployClaim: SpecStrat<
  Web3InteractionDecisionRq<Claim>,
  number
> = {
  evaluateCondition: (input: Web3InteractionDecisionRq<Claim>): boolean => {
    return input.dataStore?.claim?.status === TransactionStatus.Init;
  },
  executeAction: (input: Web3InteractionDecisionRq<Claim>): number => {
    const claim = {
      ...input.dataStore,
      claim: {
        ...input.dataStore.claim,
        status: TransactionStatus.Pending
      }
    };

    input.dispatch(updateClaim(claim));
    return 0;
  }
};
export const watchDeployClaim: SpecStrat<
  Web3InteractionDecisionRq<Claim>,
  number
> = {
  evaluateCondition: (input: Web3InteractionDecisionRq<Claim>): boolean => {
    return input.dataStore?.claim?.status === TransactionStatus.Pending;
  },
  executeAction: (input: Web3InteractionDecisionRq<Claim>): number => {
    input.dispatch(getClaim(input.dataStore));
    return 0;
  }
};
export const saveDeployClaimSuccess: SpecStrat<
  Web3InteractionDecisionRq<Claim>,
  number
> = {
  evaluateCondition: (input: Web3InteractionDecisionRq<Claim>): boolean => {
    return (
      input.dataStore.claim.status === TransactionStatus.Success &&
      !input.dataStore.claim.finishStateSaved
    );
  },
  executeAction: (input: Web3InteractionDecisionRq<Claim>): number => {
    const claim = {
      ...input.dataStore,
      claim: {
        ...input.dataStore.claim,
        finishStateSaved: true
      },
      status: TransactionStatus.Success
    };

    input.dispatch(updateClaim(claim));
    return 1;
  }
};
export const needToGoSuccessPage: SpecStrat<
  Web3InteractionDecisionRq<Claim>,
  number
> = {
  evaluateCondition: (input: Web3InteractionDecisionRq<Claim>): boolean => {
    if (
      input.location.pathname ===
      `/${PATH_OF_ROUTES.CLAIM_WEB3_INTERACTION_SUCCESS}`
    ) {
      return false;
    }
    return input.dataStore?.status === TransactionStatus.Success;
  },
  executeAction: (input: Web3InteractionDecisionRq<Claim>): number => {
    input.navigate(`/${PATH_OF_ROUTES.CLAIM_WEB3_INTERACTION_SUCCESS}`, {
      replace: true,
      state: { from: input.location }
    });
    return 2;
  }
};
export const saveClaimError: SpecStrat<
  Web3InteractionDecisionRq<Claim>,
  number
> = {
  evaluateCondition: (input: Web3InteractionDecisionRq<Claim>): boolean => {
    if (input?.dataStore?.claim?.finishStateSaved) {
      return false;
    }
    return input.error !== undefined;
  },
  executeAction: (input: Web3InteractionDecisionRq<Claim>): number => {
    const dataStore: Claim = {
      ...input.dataStore,
      claim: {
        ...input.dataStore.claim,
        status: TransactionStatus.Rejected,
        reason: input.error as TransactionReason,
        finishStateSaved: true
      },
      status: TransactionStatus.Rejected
    };

    input.dispatch(updateClaim(dataStore));
    return 0;
  }
};
export const claimDecisions = [
  saveClaimError,
  deployClaim,
  saveDeployClaim,
  watchDeployClaim,
  saveDeployClaimSuccess,
  needToGoSuccessPage
];
